/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionstatussending2Inputs */

const en_actionstatussending2 = /** @type {(inputs: Actionstatussending2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Being sent`)
};

const de_actionstatussending2 = /** @type {(inputs: Actionstatussending2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gerade verschickt`)
};

/**
* | output |
* | --- |
* | "Being sent" |
*
* @param {Actionstatussending2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionstatussending2 = /** @type {((inputs?: Actionstatussending2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionstatussending2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionstatussending2(inputs)
	return de_actionstatussending2(inputs)
});
export { actionstatussending2 as "actionStatusSending" }